import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useIsMount } from "../hooks/useIsMount.js";
import { useDispatch } from "react-redux";
import Helper from "../functions/Helper.js";

export default function RouterChanges(props) {
  const { pathname, search } = useLocation();
  const initialPath = useRef(pathname);
  const isMount = useIsMount();
  const dispatch = useDispatch();

  useEffect(() => {
    let divExists = window?.document.getElementById("main") !== null;
    if (divExists) {
      window.document.getElementById("main").style.display =
        initialPath.current === pathname ? "block" : "none";
    }
    if (!isMount) {
      dispatch({ type: "NOSSR" });

      if (typeof ga === "function") {
        ga("send", "pageview", pathname + search);
        Helper.ga4Event("page_view", { page_location: pathname + search });
      }
      //console.log("ga pageview");
    } else {
      console.log("tag manager not installed");
    }

    if (!props.urlMapping.map((x) => x.url).includes(pathname)) {
      window?.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}
